import Enum from '@/modules/core/app/helpers/Enum';

export class FinancialAccountSyncStatus extends Enum {
  static PENDING = 'pending';

  static REFRESHING_BALANCE = 'refreshing_balance';
}
